import { api } from '@/api/client';
import type {
  CancelSubscriptionResponse,
  CheckoutParams,
  CustomerPortalResponse,
  PaddleConfig,
  PlanSlug,
  SubscriptionActionResponse,
  SubscriptionPlansResponse,
} from '@/api/types';

/** Биллинг (BILL-4…7). Контракт — SubscriptionCheckoutController текущего бэкенда. */
export const billingApi = {
  plans: () => api.get<SubscriptionPlansResponse>('/subscription-plans'),
  paddleConfig: () => api.get<PaddleConfig>('/subscriptions/config'),

  /** Параметры Paddle-чекаута; 409 `subscription_exists` — подписка уже есть (BILL-5). */
  checkout: (plan: PlanSlug, correlationId: string) =>
    api.post<CheckoutParams>('/subscriptions/checkout', { plan, correlation_id: correlationId }),

  /** Снять отложенную отмену — без нового списания. */
  resume: (correlationId: string) =>
    api.post<SubscriptionActionResponse>('/subscriptions/resume', {
      correlation_id: correlationId,
    }),

  /** Смена тарифа с пропорциональным расчётом (BILL-7). */
  changePlan: (plan: PlanSlug, correlationId: string) =>
    api.post<SubscriptionActionResponse>('/subscriptions/change-plan', {
      plan,
      correlation_id: correlationId,
    }),

  /** Ссылка на Customer Portal Paddle; correlation_id — query, чтобы бэкенд приклеил его к логам. */
  portal: (correlationId: string) =>
    api.get<CustomerPortalResponse>(
      `/subscriptions/portal?correlation_id=${encodeURIComponent(correlationId)}`,
    ),

  /** Отмена в конце периода: доступ остаётся до expires_at. */
  cancel: (correlationId: string) =>
    api.post<CancelSubscriptionResponse>('/subscriptions/cancel', {
      correlation_id: correlationId,
    }),
};
